import React from 'react'

import { OtherPlatforms } from '@/containers/OtherPlatforms'

const OtherPlatformContainer: React.FC = () => {
    return <OtherPlatforms />
}

export default OtherPlatformContainer
